function Overview() {
  const calculator = new Calculator2021(CalculatorConfiguration, fundShares)
  const pensionHelper = new PensionHelper(session.pension.secondPillar)
  const sliderMinimum = 300;
  const sliderMaximum = calculateSliderMaximum();

  this.init = function () {
    pensionHelper.redirectIfSuspendOrExitIsCancelable()

    const retirementAge = Math.floor(session.pension.retirementAge)
    const retirementYear = Math.floor(session.pension.retirementYear)

    const currentSalary = session.pension.currentSalary
    const averageSalary = CalculatorConfiguration.yearlyAverageSalary

    const thirdPillar = session.pension.thirdPillar
    const estimatedPension = calculator.calculate(session.pension, thirdPillar.averageMonthlyContribution)
    const secondPillarAvailable = !session.pension.secondPillar.isExited && (
      estimatedPension.secondPillar.assetsTotal > 0 ||
      session.pension.secondPillar.activeFunds.length > 0 ||
      session.pension.secondPillar.assets.length > 0)

    const secondPillarAssets = assetsView(session.pension.secondPillar.assets).concat(investmentAccountsView(session.pension.investmentAccounts.accounts))
    const thirdPillarAssets = assetsView((thirdPillar || {assets: []}).assets)
    const contributionRate = session.pension.secondPillarContributionRate

    return {
      secondPillarContributionRate: {
        current: contributionRate.current,
        next: contributionRate.nextRates[0]?.rate,
        nextDate: contributionRate.nextRates[0]?.date
      },
      retirementAge: retirementAge,
      retirementYear: retirementYear,
      currentSalary: currentSalary || averageSalary,
      sliderMinimum: sliderMinimum,
      sliderMaximum: sliderMaximum,
      estimatedPension: estimatedPension,
      estimatedPensionFormatted: Formats.splitThousandsWithSpaces(estimatedPension.total.toFixed(0)),
      secondPillar: session.pension.secondPillar,
      secondPillarAvailable: secondPillarAvailable,
      showOptionsButton: secondPillarAvailable && !session.pension.secondPillar.isExitedOrSuspended(),
      secondPillarExited: session.pension.secondPillar.isExited,
      thirdPillar: thirdPillar,
      thirdPillarContributions: thirdPillar.contribution,
      thirdPillarAvailable: estimatedPension.thirdPillar.monthlyAmount > 0,
      secondPillarAssets: secondPillarAssets,
      thirdPillarAssets: thirdPillarAssets,
      hasThirdPillarAssets: thirdPillarAssets.length > 0,
      alreadyRetired: retirementYear <= new Date().getFullYear() || session.pension.birthYear <= 1960,
      hasInvestmentAccounts: session.pension.investmentAccounts.accounts.length > 0
    }
  }

  this.done = function (urlParams, args) {
    bind()

    if (session.showLoginDisclaimer) {
      $('#afterlogin').on('shown.bs.modal', function () {
        setTimeout(function() {
          $('#understand-terms').removeAttr('disabled');
        }, 500);
      })
      $("#afterlogin").modal('show');
    }

    $('[data-toggle="popover"]').popover({
      animation: false
    })

    let fadeIn = urlParams.fade === 'in'
    if (fadeIn) $('#page').fadeIn()

    let estimatedPension = args.estimatedPension
    if (!args.alreadyRetired) {
      new CurrentPensionChart().chart('.ct-chart', estimatedPension, args.currentSalary)
    }

    const redirectAfterLogin = localStorage.getItem('redirect-after-login')
    if (redirectAfterLogin) {
      localStorage.removeItem('redirect-after-login')
      location.href = redirectAfterLogin
    }

    checkPendingApplications()
    toggleJoinPiaLink()
  }

  function bind() {
    const salary = $('#salary').on('change', onSalarySliderChanged);
    $('#salary-slider').on('change', onSalarySliderChanged).on('input', function() { salary.val(Formats.amountWithCurrency(this.value)) });

    const contribution = $('#third-pillar-contribution').on('change', onThirdPillarContributionChanged)
    $('#third-pillar-contribution-slider').on('change', onThirdPillarContributionChanged).on('input', function() { contribution.val(Formats.amountWithCurrency(this.value)) });

    const insurance = $('#third-pillar-insurance-balance').on('change', onThirdPillarInsuranceChanged);
    $('#third-pillar-insurance-balance-slider').on('change', onThirdPillarInsuranceChanged).on('input', function() { insurance.val(Formats.amountWithCurrency(this.value)) });

    $('#afterlogin').on('click', '#understand-terms', understandTerms);
    $('#enter-third-pillar-details').on('click', enterThirdPillarInsurance);
  }

  function understandTerms() {
    session.showLoginDisclaimer = false
    $.post('/agree', {});
    $("#afterlogin").modal('hide');
  }

  function onSalarySliderChanged() {
    session.pension.currentSalary = parseNumbers(this.value)
    document.dispatchEvent(new Event('data-changed'));
  }

  function onThirdPillarContributionChanged() {
    session.pension.thirdPillar.averageMonthlyContribution = parseNumbers(this.value)
    document.dispatchEvent(new Event('data-changed'));
  }

  function onThirdPillarInsuranceChanged() {
    session.pension.thirdPillar.insuranceBalance = parseNumbers(this.value)
    document.dispatchEvent(new Event('data-changed'));
  }

  function enterThirdPillarInsurance(e) {
    e.preventDefault()
    session.pension.thirdPillar.insuranceBalance = 1
    document.dispatchEvent(new Event('data-changed'))
  }

  function calculateSliderMaximum() {
    const currentSalary = session.pension.currentSalary
    const averageSalary = CalculatorConfiguration.yearlyAverageSalary
    return currentSalary > averageSalary ? currentSalary * 2 : averageSalary * 2
  }

  function parseNumbers(value) {
    let number = parseFloat(value.replace((/[^\d.,]+/g), '').replace(',', '.'))
    return number ? number : 0
  }

  function assetsView(assets) {
    return assets.map(asset => {
      return {
        name: asset.fund.name,
        unitAmount: asset.unitAmount,
        pendingUnitAmount: asset.pendingUnitAmount,
        donut: new MiniDonut().params(asset.percent)
      }
    })
  }

  function investmentAccountsView(investmentAccounts) {
    return investmentAccounts.map(investmentAccount => {
      return {
        name: investmentAccount.operator + ' ' + investmentAccount.number,
        unitAmount: 0,
        pendingUnitAmount: 0,
        donut: undefined
      };
    }).sortBy('name')
  }

  function checkPendingApplications() {
    Fetch.get('/application/second-pillar/pending-exchange-applications/available')
      .then(function(response) {
        if (response['hasPendingApplications']) {
          $('#pending-applications-link').removeClass('d-none')
        }
      })
  }

  function toggleJoinPiaLink() {
    if (session.pension.investmentAccounts.hasLuminorPia) {
      $('#join-pia-link').addClass('d-none')
      $('#second-pillar-application-link').removeClass('d-none')
    }
  }
}